<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ql8DXY/tc-custom/FC-9781528987110.jpg?1685327175907?1709061806488" alt="This image is the cover for the book My Father's Uniform"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">My Father's Uniform
      </h1>
      <p class="bookDescription body article font2">
        <p>Every night, when mom and dad are arguing, Jetske crawls deep down under the blankets. She doesn't understand what it's about. Her mother talks about people that ended their membership in time. Her father answers that it's too late for that. Later on, Jetske understands that it's about the National Socialist Party (in Holland it's called the NSB), whose members collaborated with the Germans during the occupation of the Netherlands. That membership became a burden for Jetske and her family. In school she gets bullied and bashed from other children and some teachers neglect and bully her too. When the war is over, the suffering of Jetske and her family does not end. Her father is captured and put in prison for three years. Her mother and the children have to leave their farm. Are they allowed to come back ever? Jaitsche Wassenaar describes in this book how she felt during and just after the war as a child in the Dutch province, Friesland. As a little girl, she understands her father's choice just for a little bit. Later on, it will affect her life and that of her family massively.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jaitsche Wassenaar
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7457252a